import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { setAxiosAccountContext } from '@/utils/axios.js'
import { useCurrentAccount } from '@/hooks/useCurrentAccount.jsx'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { AnalyticsService } from '@/services/analytics.js'

export default function AccountGuard() {

    const { account } = useCurrentAccount()
    const { user } = useAuthContext()

    // Attribute analytics to the account the user actually chose (the one in the URL),
    // not accounts[0]. AccountGuard stays mounted for the whole /account/:accountId
    // subtree, so this fires once per chosen account, not on every page navigation.
    useEffect(() => {
        if (!account?._id) {
            return
        }

        const accountDataToSend = { ...account }
        delete accountDataToSend.users // the payload is too big, we don't need to send this to the analytics platforms
        AnalyticsService.group(account._id, accountDataToSend)

        if (user?._id) {
            AnalyticsService.identify(user._id, {
                account: {
                    _id: account._id,
                    name: account.name,
                    type: account.type,
                    status: account.status,
                    createdAt: account.createdAt,
                    updatedAt: account.updatedAt,
                    mainWebsite: account.mainWebsite,
                }
            })
        }
    }, [account?._id])

    if (!account) {
        // User try to access non-existing account, meaning he doesn't have access to it
        console.log('No Account?')
        return
    }

    // Not in use - if we need initialization page, we can add it here
    // if (account.isInitializing) {
    //     return <InitializingPage />
    // }

    setAxiosAccountContext(account._id)

    return <Outlet />
}